<th
  data-test="glYtlfwQ"
  *ngFor="let headerItem of items"
  [ngClass]="$any(headerItem.classes)"
>
  <ng-container *ngIf="!headerItem.sorter; else sortableHeaderItem">
    {{ headerItem.label }}
  </ng-container>
  <ng-template #sortableHeaderItem>
    <span
      data-test="iUu3Wimb"
      class="items-table__sort"
      [class.active]="headerItem.sorter === activeSorter"
      (click)="sortBy.emit(headerItem.sorter)"
    >
      {{ headerItem.label }}
    </span>
  </ng-template>
</th>
<ng-content></ng-content>
